export default __webpack_public_path__ + "static/media/6.fba07ddd.jpg";